import { CapoPlugin } from "/var/www/pec-uz.uz/www/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];